/*
 * @Descripttion:
 * @version:
 * @Author: wanglong
 * @Date: 2021-04-29 14:23:04
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-12 16:12:16
 * @* : 博虹出品，抄袭必究😄
 */
import axios from "axios";
import util from "@/plugins/utils";
import router from "@/router";
import { Message } from "element-ui";

// 创建服务
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    config.headers["Access-Control-Max-Age"] = 86400;
    config.headers.responseType = "blob";
    if (util.cookies.get("token")) {
      config.headers["token"] = util.cookies.get("token");
      if (process.env.NODE_ENV === "development") {
        config.headers["x-forwarded-for"] = "218.201.197.186";
      }
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 判断是否是流文件
    if (Object.prototype.toString.apply(response.data) == "[object Blob]") {
      return response;
    } else {
      if (res.code === 200) {
        return response.data;
      } else {
        if (res.code === 0) {
          // 一般code为0代表需要重新登录，做相应的逻辑判断即可
          return response.data;
        } else if (res.code === 401) {
          Message({
            showClose: true,
            message: res.msg || "error",
            type: "warning",
            duration: 5 * 2000,
          });
          // alert(router.app.$route.query);
          console.log(router.app.$route.query);
          //登录过期重新登录
          // store.dispatch("user/logout");
          // 计算跳转的路由
          let redirect = "";
          if (router.app.$route.query.value) {
            redirect = router.app.$route.query;
          }
          // if (back) {
          //   if (["login"].indexOf(router.app.$route.name) < 0)
          //     redirect = router.app.$route.fullPath;
          //   else redirect = router.app.$route.query.redirect;
          // }
          // 重置权限并且跳转到登录页 通过 back 参数指定在登陆之后是否需要跳转回原来的页面
          // console.log(redirect);
          router.replace({
            name: "login",
            query: redirect
              ? {
                  ...redirect,
                }
              : {},
          });
        } else {
          Message({
            showClose: true,
            message: res.msg || "error",
            type: "error",
            duration: 5 * 2000,
          });
          return Promise.reject(res.msg || 'error')
          //return res;
        }
      }
    }
  },
  (error) => {
    Message({
      showClose: true,
      message: "系统连接失败，请稍侯再试",
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
